import React, { useState } from "react";
import {
  Box,
  Container,
  Paper,
  Tabs,
  Tab,
  Typography,
} from "@mui/material";
import {
  School as SchoolIcon,
  RateReview as FeedbackIcon,
  ViewCarousel as BannerIcon,
} from "@mui/icons-material";
import CourseAdsList from "./CourseAdsList";
import FeedbacksList from "./FeedbacksList";
import HeroBannersList from "./HeroBannersList";

const TabPanel = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
};

const HomepageManagement = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 700,
            background: "linear-gradient(135deg, #2196F3 0%, #1976D2 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 1,
          }}
        >
          Homepage Marketing Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage course advertisements and student feedback displayed on the homepage
        </Typography>
      </Box>

      <Paper sx={{ borderRadius: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            px: 2,
          }}
        >
          <Tab
            icon={<BannerIcon />}
            iconPosition="start"
            label="Hero Banners"
            sx={{ textTransform: "none", fontWeight: 600 }}
          />
          <Tab
            icon={<SchoolIcon />}
            iconPosition="start"
            label="Course Ads"
            sx={{ textTransform: "none", fontWeight: 600 }}
          />
          <Tab
            icon={<FeedbackIcon />}
            iconPosition="start"
            label="Student Feedbacks"
            sx={{ textTransform: "none", fontWeight: 600 }}
          />
        </Tabs>

        <Box sx={{ p: 3 }}>
          <TabPanel value={activeTab} index={0}>
            <HeroBannersList />
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            <CourseAdsList />
          </TabPanel>
          <TabPanel value={activeTab} index={2}>
            <FeedbacksList />
          </TabPanel>
        </Box>
      </Paper>
    </Container>
  );
};

export default HomepageManagement;
